import React, { useEffect } from "react";
import Header from "components/Common/Header";
import Footer from "components/Common/Footer";
import ActivityBar from "components/Common/ActivityBar";
import ExploreBar from "components/Common/ExploreBar";
import DocumentBar from "./DocumentBar";
import ToolBar from "./ToolBar";
import ChangeClient from "components/Common/ChangeClient";
import { useSelector } from "react-redux";
import { getSelectedClient } from "store/actions/clientAction";
import isEmpty from "lodash/isEmpty";

const Dashboard = () => {
  const selectedClient = useSelector(state => state.client.selectedClient);

  useEffect(() => {
    getSelectedClient();
  }, []);

  return (
    <>
      {/* Header */}
      <Header />

      <ChangeClient
        toggleHandleChange={() => {}}
        showModal={isEmpty(selectedClient)}
      />

      {/* Main Content */}

      <main className="main-content">
        <div className="dashboard">
          {/* Activity Bar */}
          <ActivityBar />

          {/* ExploreBar */}
          <ExploreBar />

          {/* DocumentBar */}
          <DocumentBar />

          {/* Toolbar */}
          <ToolBar />
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Dashboard;
